import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import KnowledgePanel from '../knowledge-panel/knowledge-panel';
import CommunityPanel from '../community-panel/community-panel';
import { SubjectModel } from '@/models/taxonomy/subject';
import { ClassificationModel } from '@/models/taxonomy/classification';
import { DomainModel } from '@/models/proficiency/domain';
import moment from 'moment';
import MindsetsPanel from '../mindsets-panel/mindsets-panel';

import { Domain } from '@/models/proficiency/domain-topic/domain';
import { Topic } from '@/models/proficiency/domain-topic/topic';
import { Competency } from '@/models/proficiency/domain-topic/competency';
import RouteGeneratePanel from '../route-generate-panel/route-generate-panel';
import { CompetencyModel } from '@/models/proficiency/competency';
import { RGDomainModel } from '@/models/proficiency/route-generator';
import { appConfigService } from '@/providers/services/app/app-config';
import TopicJourneyPanelComponent from '../topic-journey-panel/topic-journey-panel';

@Component({
  name: 'topic-info-panel',
  components: {
    'google-material-icon': GoogleMaterialIcon,
    MindsetsPanel,
    KnowledgePanel,
    CommunityPanel,
    'rg-panel': RouteGeneratePanel,
    'topic-journey-panel': TopicJourneyPanelComponent,
  },
})
export default class TopicInfoPanel extends Vue {

  private get isSuperUser() {
    return this.$access.hasPermission('all', 'all');
  }

  private get isDemoTenant() {
    return appConfigService.isDemoTenant();
  }

  @Prop()
  public domain!: Domain;

  @Prop()
  public subject!: SubjectModel;

  @Prop()
  public classification!: ClassificationModel;

  @Prop()
  public activeToggleList?: string;

  @Prop()
  public portfolioDomain: any;

  @Prop()
  public isShowcasePage!: boolean;

  public activeTab: object = {
    title: 'Knowledge',
    component: KnowledgePanel,
  };

  public tabItems = [
    {
      title: 'Knowledge',
      component: KnowledgePanel,
    },
    {
      title: this.isShowcasePage ? 'Journey' : 'Mindset',
      component: this.isShowcasePage ? 'topic-journey-panel' : MindsetsPanel,
    },
    {
      title: 'Citizenship',
      component: CommunityPanel,
    },
  ];

  public isLoading: boolean = false;

  @Prop()
  private activeClasses: any;

  @Prop({default: {}})
  private competency!: CompetencyModel;

  @Prop()
  private rgDomains!: RGDomainModel[];

  @Prop()
  private isShowRouteGenerate!: boolean;

  @Prop()
  private topic!: Topic;

  @Prop()
  private userId!: string;

  @Prop()
  private month!: string;

  @Prop()
  private year!: string;

  public onSelectCompetency(competency: Competency) {
    this.$emit('onSelectCompetency', competency);
  }

  public onSelectTopic(topic: Topic) {
    this.$emit('onSelectTopic', topic);
  }


  private onSelectPortfolioStat(portfolio: any) {
    this.$emit('onSelectPortfolioStat', portfolio);
  }

  private showRoutes() {
    this.$emit('onShowRouteLine', true);
  }


  private onCloseRoute() {
    this.$emit('onShowRouteLine', false);
  }

  @Watch('topic')
  private onRefreshTopic() {
    this.isLoading = true;
    this.isLoading = false;
  }
}
